module.exports = __webpack_public_path__ + "img/num_layout_05.0c85bcbb.png";